import { useQuery } from '@tanstack/react-query';
import { biodataApi } from '../services/biodata.service';
import { queryKeys } from '../lib/react-query';

export const useBiodata = ({ employerNumber, staffNumber }) => {
  return useQuery({
    queryKey: [queryKeys.biodata, employerNumber, staffNumber],
    queryFn: async () => {
      const res = await biodataApi.getBioData({ employer_number: employerNumber, staff_number: staffNumber });
      return res.data;
    },
    // Allow fetching if we have at least a staff identifier or employer identifier
    enabled: !!employerNumber || !!staffNumber,
    staleTime: 30 * 1000, // Reduced to 30 seconds to ensure fresher data
  });
};

export default useBiodata;
